export const HTMLDecode = text => {
  var temp = document.createElement("div");
  temp.innerHTML = text;
  var output = temp.innerText || temp.textContent;
  temp = null;
  if (output == "undefined") {
    return "";
  } else {
    return output;
  }
};
export default {
  install: function(Vue) {
    Vue.prototype.downloadfile = url => {
      var a = document.createElement("a"), //创建a标签
        e = document.createEvent("MouseEvents"); //创建鼠标事件对象
      e.initEvent("click", false, false); //初始化事件对象
      a.href = url; //设置下载地址
      a.dispatchEvent(e); //给指定的元素，执行事件click事件
    };
  }
};
